module.exports = __webpack_public_path__ + "img/hometop_lg.08f7dc59.png";